// Extension `.js` OBLIGATOIRE : ce fichier est aussi chargé tel quel par les fonctions serveur
// (`api/invite-user.js`, `api/export-tenant.js`), sans bundler, où Node ESM ne résout pas un
// import relatif sans extension (garde : `apiModulesChargeables.test.js`).
import { isAssignmentActive } from '../services/scopeHierarchy.js';

export const LEGACY_TO_SYSTEM = {
  Master: 'master',
  // P0 frontière plateforme, sous-lot E (2026-07-23) : les libellés historiques
  // IT / Administrateur ne résolvent PLUS vers 'master'. Cible sémantique
  // canonique = 'it_admin' (rôle tenant-scopé, lecture seule, sans pouvoir
  // plateforme). C'est fail-closed : même un compte IT sans tenant résout vers
  // it_admin (0 pouvoir, cockpit blocked_rbac), jamais vers master. La migration
  // NOMINATIVE des comptes (et la quarantaine des ambigus) reste le sous-lot B.
  Administrateur: 'it_admin',
  IT: 'it_admin',
  DG: 'dg',
  'Direction G\u00e9n\u00e9rale': 'dg',
  Recteur: 'dg',
  'Pr\u00e9sident': 'dg',
  'Vice-Chancelier': 'dg',
  Provost: 'dg',
  Principal: 'dg',
  'Directeur Acad\u00e9mique': 'directeur',
  'Direction des \u00e9coles': 'directeur',
  'Directeur des \u00e9coles': 'directeur',
  Doyen: 'directeur',
  "Directeur d'\u00c9cole": 'directeur',
  'Directeur Ecole': 'directeur',
  Directeur: 'directeur',
  'Chef de D\u00e9partement': 'directeur',
  'Coordonnateur de Programme': 'resp_academique',
  'Coordonnateur de Cycle': 'resp_academique',
  // Ajout\u00e9 2026-07-16 (portail r\u00f4le coord_niveau, couche Portails R\u00f4les CBAC).
  'Coordonnateur de Niveau': 'resp_academique',
  'Responsable Acad\u00e9mique': 'resp_academique',
  'Responsable de Fili\u00e8re': 'resp_academique',
  'R\u00e9f\u00e9rent de Sp\u00e9cialit\u00e9': 'resp_academique',
  'Charg\u00e9 Acad\u00e9mique': 'resp_academique',
  'Responsable Recherche': 'resp_academique',
  // Arbitrage utilisateur 2026-10-04 : role systeme DEDIE (reconciliation avec
  // useGovAccess.js::LEGACY_TO_SYSTEM, qui fait foi) ; etait un alias de
  // resp_academique.
  'Responsable D\u00e9veloppement': 'dev_inst',
  // Corrig\u00e9 2026-07-16 (audit CBAC, chantier Portails R\u00f4les) : ce fichier
  // n'avait jamais \u00e9t\u00e9 mis \u00e0 jour lors de la cr\u00e9ation des r\u00f4les syst\u00e8me
  // 'controle'/'amelioration' (2026-07-10) \u2014 'Responsable Qualit\u00e9'/'Manager
  // Qualit\u00e9' pointaient \u00e0 tort vers 'resp_academique' (divergence avec
  // useGovAccess.js::LEGACY_TO_SYSTEM, qui fait foi). Comme resolveSystemRoleId
  // de CE fichier est la fonction r\u00e9ellement utilis\u00e9e par useGovAccess().can()
  // (import direct), cette erreur aurait pu priver tout utilisateur portant
  // ce r\u00f4le legacy des capacit\u00e9s r\u00e9elles de 'controle' (quality/audit/risques)
  // depuis le rollout du portail Contr\u00f4ler (2026-07-15).
  'Responsable Qualit\u00e9': 'controle',
  'Manager Qualit\u00e9': 'controle',
  'Responsable Audit': 'controle',
  'Contr\u00f4leur Interne': 'controle',
  'Responsable Conformit\u00e9': 'controle',
  'Responsable PMO': 'amelioration',
  'Directeur PMO': 'amelioration',
  'Responsable Innovation': 'amelioration',
  'Responsable Transformation': 'amelioration',
  'Gestionnaire Scolarité': 'registraire',
  'Responsable Admissions': 'registraire',
  Registraire: 'registraire',
  'Registraire Institutionnel': 'registraire',
  'Bureau du Registraire': 'registraire',
  'Assistant Registraire': 'registraire',
  'Assistante Registraire': 'registraire',
  'Adjoint Registraire': 'registraire',
  'Adjointe Registraire': 'registraire',
  'Agent Comptable': 'gestionnaire',
  Enseignant: 'enseignant',
  // Gouvernés 2026-10-03 (arbitrage d'Alfred) : ces deux libellés atterrissaient
  // par le repli PRODUIRE sans rôle système ; ils résolvent désormais vers
  // 'enseignant', comme 'Enseignant' et 'Vacataire' (registre, copie
  // useGovAccess et exécution alignés).
  'Enseignant Permanent': 'enseignant',
  'Enseignant Associ\u00e9': 'enseignant',
  Vacataire: 'enseignant',
  Tuteur: 'enseignant',
  Encadreur: 'enseignant',
  Apprenant: 'etudiant',
  '\u00c9tudiant': 'etudiant',
  Parent: 'parent',
  Auditeur: null,
  Observateur: null,
  // R\u00f4les CBAC sp\u00e9cialis\u00e9s v4 (2026-07-14, respect du nombre d'\u00e9crans-portail
  // prescrits) \u2014 libell\u00e9s EXACTS du prototype pour \u00e9viter toute collision avec
  // les libell\u00e9s g\u00e9n\u00e9riques existants ci-dessus (ex. 'Responsable Recherche'
  // \u2260 'Responsable de la Recherche').
  'Responsable des Ressources Humaines': 'rrh',
  'Directeur Administratif et Financier': 'daf',
  'Responsable de la Recherche': 'resp_rech',
  'Responsable Logistique et Patrimoine': 'resp_log',
  'Responsable Communication': 'resp_com',
};

const SYSTEM_ROLE_IDS = new Set([
  'master',
  'dg',
  'directeur',
  'resp_academique',
  'gestionnaire',
  'enseignant',
  'etudiant',
  'parent',
  'rrh',
  'daf',
  'resp_rech',
  'resp_log',
  'resp_com',
  // Ajoutés 2026-07-16 (réconciliation avec useGovAccess.js::LEGACY_TO_SYSTEM,
  // qui fait foi) — absents ici depuis leur création le 2026-07-10.
  'controle',
  'amelioration',
  // P0 frontière plateforme (sous-lot A, 2026-07-23) : rôle système canonique
  // de l'administrateur informatique d'établissement, tenant-scopé. Créé SANS
  // aucun pouvoir plateforme et SANS assimilation à 'master'. Le mapping legacy
  // IT/Administrateur -> it_admin est préparé mais PAS encore appliqué (dette du
  // sous-lot E). Aucune capacité ne lui est accordée ici : les deux envisagées
  // (governance, admin) ouvrent des routes plateforme (recteur, capability-store,
  // core-platform…) — une capacité tenant-scopée précise est différée au
  // sous-lot serveur. Voir docs/P0_IT_ADMIN_PLATFORM_BOUNDARY.md.
  'it_admin',
  // Arbitrage utilisateur 2026-10-04 : rôle système dédié de Développement
  // Institutionnel & Marketing (était un alias de resp_academique).
  'dev_inst',
]);

const normalizeRoleKey = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

const NORMALIZED_LEGACY_TO_SYSTEM = Object.fromEntries(
  Object.entries(LEGACY_TO_SYSTEM).map(([label, systemRoleId]) => [normalizeRoleKey(label), systemRoleId])
);

const pickKnownSystemRoleId = (value) => {
  const key = normalizeRoleKey(value);
  return SYSTEM_ROLE_IDS.has(key) ? key : null;
};

/**
 * Ce libellé est-il DÉCLARÉ sans rôle système — par opposition à simplement
 * inconnu de la carte ?
 *
 * La distinction porte tout le correctif du 2026-09-06. `resolveHomePortal` se
 * termine par `SYSTEM_ROLE_TO_PORTAL[sysRoleId] || PRODUIRE` : un rôle sans
 * rôle système obtenait donc le portail PRODUIRE, et avec lui `/dashboard/results`,
 * `students`, `deliberations`, `teachers`. Mesuré : `Auditeur` et `Observateur`
 * atteignaient ces quatre routes alors qu'un **Enseignant n'en atteint aucune**.
 * Un rôle déclaré sans accès en avait plus qu'un enseignant.
 *
 * Fermer ce repli d'un bloc aurait casse les rôles REELS qui en dependent —
 * `Comptable`, `Personnel` sont ABSENTS de la carte et
 * atterrissent grâce à lui. D'où la distinction :
 *
 *   · valeur explicitement `null`  → déclaré sans portail, on ferme ;
 *   · clé absente                  → libellé inconnu, le repli demeure.
 *
 * Seuls `Auditeur` et `Observateur` sont explicitement `null`, et le registre le
 * justifie : « Aucun cockpit natif, aucune route d'atterrissage déclarée, aucun
 * usage en production » (role-authority-registry.json:331).
 */
export function roleDeclareSansPortail(legacyRole) {
  const cle = normalizeRoleKey(legacyRole);
  if (!cle) return false;
  return Object.prototype.hasOwnProperty.call(NORMALIZED_LEGACY_TO_SYSTEM, cle)
    && NORMALIZED_LEGACY_TO_SYSTEM[cle] === null;
}

export function resolveSystemRoleId(subject, options = {}) {
  const { includeLegacyRole = true } = options;

  if (typeof subject === 'string') {
    return pickKnownSystemRoleId(subject) || NORMALIZED_LEGACY_TO_SYSTEM[normalizeRoleKey(subject)] || null;
  }

  const directCandidates = [
    subject?.system_role_id,
    subject?.sysRoleId,
    subject?.systemRoleId,
    subject?.role_id,
    subject?.roleKey,
  ];

  const directSystemRoleId = directCandidates.map(pickKnownSystemRoleId).find(Boolean);
  if (directSystemRoleId) return directSystemRoleId;

  if (!includeLegacyRole) return null;

  const legacyRole = subject?.role;
  return NORMALIZED_LEGACY_TO_SYSTEM[normalizeRoleKey(legacyRole)] ?? null;
}

/**
 * Rôles de tenant qui ENDOSSENT un rôle système : qui en porte une affectation active a, en plus du sien, le
 * portail (menu et écrans) de ce rôle système. `it_ecole` = adjoint technique du Directeur, aux capacités
 * EXACTEMENT égales (migration 20261031181000) : il lui faut donc le même menu. Sans cela le portail restait
 * décidé par `profiles.role` seul (`IT` → Soutenir) et l'IT coopté (Jean Paul, 2026-11-02) ne voyait rien de
 * plus que ce qu'il avait avant.
 */
export const ROLE_SYSTEME_ENDOSSE = Object.freeze({ it_ecole: 'directeur' });

/** Rôles système endossés par des affectations (dynamic : `[{ is_active, role: { code }, … }]`). */
export function rolesSystemeEndosses(assignments) {
  const ids = new Set();
  for (const ra of assignments || []) {
    const id = ROLE_SYSTEME_ENDOSSE[ra?.role?.code];
    if (id && isAssignmentActive(ra)) ids.add(id);
  }
  return [...ids];
}

export function hasSystemRole(subject, expectedRoleIds, options = {}) {
  const roleIds = Array.isArray(expectedRoleIds) ? expectedRoleIds : [expectedRoleIds];
  const systemRoleId = resolveSystemRoleId(subject, options);
  return roleIds.map(normalizeRoleKey).includes(systemRoleId);
}

export function hasLegacyRole(subject, expectedRoles) {
  const roles = Array.isArray(expectedRoles) ? expectedRoles : [expectedRoles];
  const current = normalizeRoleKey(subject?.role);
  return roles.map(normalizeRoleKey).includes(current);
}

export function hasMasterWorkspaceAccess(subject, accessEvidence = {}) {
  if (accessEvidence.masterAccessGranted === true) return true;
  if (accessEvidence.canManagePlatform === true) return true;
  return hasSystemRole(subject, 'master', { includeLegacyRole: false });
}
